import React from "react";
import { Main, Section, Aside } from "../../../layout/index";
import { Posts, MakePost } from "../../../components/index";
import "./PracticeOpportunities.css";

const PracticeOpportunities = () => {
  const navList = [
    {
      label: "Employment Opportunities",
      value: "employment-opportunities",
      key: 1,
    },
    {
      label: "Practice Opportunities",
      value: "practice-opportunities",
      key: 2,
    },
    {
      label: "Other",
      value: "other",
      key: 3,
    },
  ];

  return (
    <Main slug="practice" title="PRACTICE OPPORTUNITIES">
      <Aside header="CLASSIFIEDS" navList={navList} active={2}>
        <MakePost />
      </Aside>
      <Section>
        <Posts categoryID={3} />
      </Section>
    </Main>
  );
};

export default PracticeOpportunities;
